<template>
  <div>
    <v-layout column>
      <v-flex>
        <SmartAgentManager
          :agent-code="agentCode"
          :showCategories="showCategories"
        />
        <v-flex>
          <p class="red--text mt-2 display-14">{{ validateError }}</p>
          <span v-if="showCategories" class="red--text display-16 d-block pr-2">
            * לאור שינויים שבוצעו באתר - אנא הגדירו מחדש את התפקיד שמעניין אתכם
          </span>
        </v-flex>
      </v-flex>

      <v-flex class="text-center">
        <!-- :btn-enabled="!allowSettings" -->
        <DrBtn
          :type-btn="'orange_btn_large mob display-22 my-6 '"
          :action="registerSmartAlerts"
          :loader="inProcess"
          :btn-enabled="!allowSettings"
        >
        שמירת הגדרות
        </DrBtn>
      </v-flex>

      <v-dialog v-model="alertAgent" width="500" min-height="150">
        <v-card class="py-3">
          <v-row>
            <v-col class="pb-0">
              <p class="text-center mt-3 mb-2">
                סוכן חכם זה כבר קיים. יש לשנות הגדרות חיפוש
              </p>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="text-center">
              <v-btn
                color="primary"
                class="px-5"
                height="35"
                width="100"
                large
                rounded
                @click="alertAgent = false"
              >
                סגור
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import SmartAgentManager from '@/components/Candidates/Pages/SmartAgentManager/SmartAgentManager';
import { has } from 'lodash';

import { t } from '@/store/modules/homeDrushim/constantsContent';
import { UPDATE_SMART_ALERTS } from '@/lib/api.js';

export default {
  components: {
    SmartAgentManager,
  },
  data() {
    return {
      submitBtnLabel: t('titles.candidates.smartAlertsBtn'),
      inProcess: false,
      validateError: '',
      locations: null,
      validateLocations: null,
      alertAgent: false,
      AgentVersion: {
        V0: true,
        V1: false,
      },
    };
  },
  props: {
    agentCode: {
      type: String,
      default: null,
      required: true,
    },
  },

  computed: {
    ...mapGetters(['getLocal', 'allowSettingsSend']),
    ...mapState({
      agentActive: (state) => state.smartAlertsSettings.allSettingsData.Active,
      // keywordsJD: (state) => state.smartAlertsSettings.allSettingsData.Keywords,
      AgentVersionType: (state) =>
        state.smartAlertsSettings.allSettingsData.AgentVersion,
    }),

    allowSettings() {
      return !!this.allowSettingsSend;
    },

    isSecondaryCategorySelected() {
      return !!this.getLocal.secondaryCategory;
    },

    showCategories() {
      let status = this.AgentVersion[this.AgentVersionType];
      return status;
    },
  },

  methods: {
    async registerSmartAlerts() {
      this.validateError = '';
      this.$nuxt.$loading.start();
      this.inProcess = true;

      let data = {
        Categories:
          this.getLocal.mainCategory && this.showCategories
            ? {
                [this.getLocal.mainCategory?.Code]:
                  this.getLocal.mainSubCategories,
                ...(this.getLocal.secondaryCategory?.Code && {
                  [this.getLocal.secondaryCategory.Code]:
                    this.getLocal.secondarySubCategories,
                }),
              }
            : {},
        Scopes: this.getLocal.scopes,
        Experiences: this.getLocal.experience,
        Locations: this.getLocal.locations,
        Keywords: this.getLocal.keywordsJD.length
          ? [this.getLocal.keywordsJD]
          : [],
        AgentCode: parseInt(this.agentCode),
        Type: this.getLocal.alertsType.Code || 1,
      };

      try {
        await this.$axios
          .post(`${UPDATE_SMART_ALERTS}/update/`, data)
          .then((res) => {
            if (res.data.IsError) {
              throw res.data.Errors;
            }

            this.redirecToMyBoard();
          });
      } catch (e) {
        if (has(e, 'MustChooseSubCategory')) {
          this.validateError = '* נא בחר תחומים ';
        } else if (has(e, 'DuplicateAgent')) {
          this.alertAgent = true;
        } else {
          this.validateError = 'שגיאת רישום';
        }
        this.$nuxt.$loading.finish();
        this.inProcess = false;
        console.log('FAILURE!!', e);
      }
    },

    async signUpForSmartAlerts() {
      let mailingFrequency = this.getLocal.mailing;

      if (this.getLocal.allowMailing) {
        try {
          this.$axios
            .post(`${UPDATE_SMART_ALERTS}/changefrequency`, mailingFrequency)
            .then((res) => {
              if (res.data.IsError) {
                throw res.data.Errors;
              }
            });
        } catch (e) {
          console.log('failed update mailing freq ', e);
        }
      } else {
        try {
          this.$axios.post(`${UPDATE_SMART_ALERTS}/remove`).then((res) => {
            if (res.data.IsError) {
              throw res.data.Errors;
            }
          });
        } catch (e) {
          console.log('failed remove from mailing ', e);
        }
      }
    },

    async redirecToMyBoard() {
      /** Clear local setting state */
      await this.$store.dispatch('resetLocalState');
      await this.$auth.fetchUser();
      this.$router.push('/personal/smartalertsnotification');
    },
  },
};
</script>

<style lang="scss" scoped>
.check-item {
  background-color: transparent;
}

.smart-item-fields {
  align-self: center;
}

@media only screen and (min-width: 600px) {
  .smart-item-selection {
    margin-right: 20px;
  }

  .smart-item-title {
    padding: 8px 0;
    border-left: 1px solid white;
  }

  .check-item {
    background-color: $darkGray;
    padding: 25px 5px;
  }

  .smart-item-fields {
    margin-right: 15px;
  }
}

@media only screen and (min-width: 960px) {
}

@media only screen and (min-width: 1264px) {
}
</style>
